import { render, staticRenderFns } from "./ArticleReport.vue?vue&type=template&id=30571c20&scoped=true&"
import script from "./ArticleReport.vue?vue&type=script&lang=js&"
export * from "./ArticleReport.vue?vue&type=script&lang=js&"
import style0 from "./ArticleReport.vue?vue&type=style&index=0&id=30571c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30571c20",
  null
  
)

export default component.exports